import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpEvent,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { Injectable } from "@angular/core";

@Injectable()
export class HeadersInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (
      req.url.indexOf("/SancionesPersonas/Crear") > -1 ||
      req.url.indexOf("/SancionesPersonas/Actualizar") > -1 ||
      req.url.indexOf("/SancionesPersonas/Inactivar") > -1 ||
      req.url.indexOf("/Sanciones/Crear") > -1 ||
      req.url.indexOf("/NotificacionesMasivasAdministrador/RedactarMensaje") > -1 ||
      req.url.indexOf("/SancionesPersonas/Eliminar") > -1 ||
      req.url.indexOf("/Archivo/SubirDocumento") > -1 ||
      req.url.indexOf("/sanciones/CambiarEstadoSancion") > -1 ||
      req.url.indexOf("/ContenidoCertificadoAdministrador/SubirDocumento") > -1
    ) {
      return next.handle(req);
    }
    const authReq = req.clone({
      headers: req.headers
        .set("Content-Type", "application/json; charset=utf-8")
        .set(
          "Accept",
          req.url.indexOf("/ContenidoCertificado/ObtenerRecurso") > -1
            ? "*"
            : req.url.indexOf("/ExpedirCertificado") > -1 ||
              req.url.indexOf("/ExpedirCertificadoRegistro") > -1 ||
              req.url.indexOf("/sanciones/descargarDocumentoSancion") > -1 ||
              req.url.indexOf("/DocumentoDetalleSolicitud/DescargarDocumento") >
                -1
            ? "application/pdf"
            : "application/json"
        )
        .set("Access-Control-Allow-Origin", "*")
        .set(
          "Access-Control-Allow-Headers",
          "Origin, X-Requested-With, Content-Type, Accept"
        ),
    });
    return next.handle(authReq);
  }
}
